/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2023-10-10 10:40:30
 * @LastEditors: WangYuhan
 */
const state = {
  // 导航栏菜单是否隐藏
  isCollapse: false,
  // 导航栏列表数据
  menusList: [],
  menusListBottom: [],
  showBottomMenu: true,
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  // 更新一级导航点击的索引
  updateMenusNavIndex(state, payload) {
    state.menusNavIndex = payload;
  },
  // 更新二级侧边栏一级侧边栏索引改变
  updateSecondNavIndex(state, index) {
    state.updatNavIndex = index;
  },
  // 更新二级导航显示隐藏
  updateIsCollapse(state, payload) {
    state.isCollapse = payload;
  },
  updataMenusListBottom(state, payload) {
    state.menusListBottom = payload;
  },
  // 更新菜单
  updateMenu(state, payload) {
    state.menusList = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
